import { BarChart3, DownloadCloud } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { MarketInsightsModal } from "@/components/MarketInsightsModal";

const initialValuationForm = { name: "", phone: "", email: "", notes: "" };

export const SellerLeadMagnet = ({ contextLabel, heading, description, testIdPrefix = "seller-magnet" }) => {
  const [form, setForm] = useState(initialValuationForm);
  const [submitting, setSubmitting] = useState(false);
  const [insightsOpen, setInsightsOpen] = useState(false);

  const handleValuationSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    try {
      await api.post("/contact-lead", {
        ...form,
        inquiry_type: "free-property-valuation",
        lead_source: "homepage",
        capture_context: contextLabel || "Homepage seller lead magnet",
        captured_route: window.location.pathname,
        notes: `${form.notes} | Context: ${contextLabel}`,
      });
      toast.success("Your free valuation request has been sent");
      setForm(initialValuationForm);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Unable to send your valuation request right now");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
        <form className="luxury-panel grid gap-4 p-6 md:p-8" data-testid={`${testIdPrefix}-valuation-form`} onSubmit={handleValuationSubmit}>
          <div className="flex items-center gap-3 text-[#D4AF37]">
            <BarChart3 className="h-5 w-5" />
            <p className="subtle-label">Free Property Valuation</p>
          </div>
          <h3 className="text-3xl font-semibold text-white">{heading}</h3>
          <p className="text-sm leading-7 text-slate-300">{description}</p>
          <input className="field-shell" data-testid={`${testIdPrefix}-name-input`} onChange={(event) => setForm({ ...form, name: event.target.value })} placeholder="Full Name" required value={form.name} />
          <input className="field-shell" data-testid={`${testIdPrefix}-phone-input`} onChange={(event) => setForm({ ...form, phone: event.target.value })} placeholder="Phone Number" required value={form.phone} />
          <input className="field-shell" data-testid={`${testIdPrefix}-email-input`} onChange={(event) => setForm({ ...form, email: event.target.value })} placeholder="Email Address" required type="email" value={form.email} />
          <textarea className="field-shell min-h-32" data-testid={`${testIdPrefix}-notes-input`} onChange={(event) => setForm({ ...form, notes: event.target.value })} placeholder="Tell me about your property, timing, or selling goals" value={form.notes} />
          <button className="gold-button w-full" data-testid={`${testIdPrefix}-submit-button`} disabled={submitting} type="submit">
            Request Free Valuation
          </button>
        </form>

        <div className="luxury-panel flex flex-col justify-between p-6 md:p-8" data-testid={`${testIdPrefix}-insights-card`}>
          <div>
            <div className="flex items-center gap-3 text-[#D4AF37]">
              <DownloadCloud className="h-5 w-5" />
              <p className="subtle-label">2026 Market Insights</p>
            </div>
            <h3 className="mt-4 text-3xl font-semibold text-white">Capture sellers with a branded market report.</h3>
            <p className="mt-4 text-sm leading-7 text-slate-300">
              This lead magnet covers pricing momentum, buyer sensitivity, valuation positioning, and April 2026 tax changes so owners can act with stronger context.
            </p>
          </div>
          <button className="outline-button mt-6" data-testid={`${testIdPrefix}-download-button`} onClick={() => setInsightsOpen(true)} type="button">
            Unlock 2026 Market Insights
          </button>
        </div>
      </div>

      <MarketInsightsModal contextLabel={contextLabel} onClose={() => setInsightsOpen(false)} open={insightsOpen} testIdPrefix={`${testIdPrefix}-market-insights`} />
    </>
  );
};